export function damageRates(parts) {
    const rotationDps = parts.fullDps?.dps ?? 0;
    const inRotation = rotationDps > 0;
    const primaryDps = inRotation ? rotationDps : (parts.dps?.dps ?? 0);
    const procDps = (inRotation ? parts.fullDps?.procDps : parts.dps?.procDps) ?? 0;
    const ailmentDps = (inRotation ? parts.fullDps?.ailmentDps : parts.dps?.ailmentDps) ?? 0;
    // Always the single skill's, even inside a rotation: `FullDpsResult` carries no summon term at
    // all, so there is nothing to double-count and nothing else to read. A rotation of two summon
    // skills therefore reports only the main one's pets — an undercount, which is the direction to
    // be wrong in, and one the engine would have to grow a field to fix.
    const summonDps = parts.dps?.summonDps ?? 0;
    const basicDps = parts.basicDps ?? 0;
    const basicProcDps = parts.basicProcDps ?? 0;
    return {
        inRotation,
        primaryDps,
        procDps,
        ailmentDps,
        summonDps,
        basicDps,
        basicProcDps,
        total: primaryDps + (inRotation ? 0 : procDps) + ailmentDps + summonDps + basicDps + basicProcDps,
    };
}
//# sourceMappingURL=rates.js.map